package com.netguru.multiplatform.charts.theme

import androidx.compose.runtime.*
import androidx.compose.ui.graphics.*

@Immutable
data class ChartColors(
    val primary: Color,
    val surface: Color,
    val grid: Color,
    val emptyGasBottle: Color,
    val fullGasBottle: Color,
    val overlayLine: Color,
)
